/* Tickets SAC (Shopysale) del Centro de ayuda — formulario + "Mi ticket".
   Ver snippets/tt-sac-ticket-form.liquid y snippets/tt-sac-ticket-view.liquid.
   · Config del formulario (GET /public/tickets/form) con caché en localStorage (10 min, se
     usa al instante al recargar y se renueva en segundo plano).
   · Tipos de consulta como interruptores (uno a la vez: cada ticket tiene un solo tipo).
   · Campos de compra/producto solo si el tipo los exige (requiredFields).
   · Adjuntos a S3 con URL firmada. Honeypot "website".
   · Omnicanal: al crear el ticket se ofrece seguir por WhatsApp con el n° SAC en el mensaje;
     "Mi ticket" muestra estado + conversación, permite responder y reenviar el link.
   Expone window.ttSac.init(root) para formularios dibujados por el JS del centro de ayuda. */
(function () {
  'use strict';
  var FORM_CACHE = 'tt_sac_form_v1', FORM_TTL = 10 * 60 * 1000;

  function cfgOf(el) {
    var host = el.closest('[data-tt-help],[data-tt-sac-host]') || document.querySelector('[data-tt-help],[data-tt-sac-host]') || el;
    return {
      api: String(host.getAttribute('data-sac-api') || '').replace(/\/+$/, ''),
      key: host.getAttribute('data-sac-key') || '',
      wa: host.getAttribute('data-wa') || '',
      page: host.getAttribute('data-sac-page') || location.pathname
    };
  }
  function call(c, path, opts, tries) {
    opts = opts || {};
    tries = tries || 0;
    var method = opts.method || 'GET';
    var headers = { 'X-Ticket-Key': c.key };
    if (opts.body) headers['Content-Type'] = 'application/json';
    if (opts.token) headers['X-Ticket-Token'] = opts.token;
    return fetch(c.api + path, { method: method, headers: headers, body: opts.body ? JSON.stringify(opts.body) : undefined })
      .then(function (r) {
        // Caída momentánea del servidor (5xx): las CONSULTAS se reintentan solas (2 veces). Los envíos no, para no duplicar.
        if (r.status >= 500 && method === 'GET' && tries < 2) {
          return new Promise(function (ok) { setTimeout(ok, 1200 * (tries + 1)); }).then(function () { return call(c, path, opts, tries + 1); });
        }
        return r.json().catch(function () { return { ok: false, msg: 'Error de conexión' }; }).then(function (j) {
          if (!r.ok || j.ok === false) { var e = new Error(j.msg || ('HTTP ' + r.status)); e.status = r.status; e.errors = j.errors || {}; throw e; }
          return j;
        });
      });
  }
  function cacheGet(k, ttl) { try { var c = JSON.parse(localStorage.getItem(k) || 'null'); return c && c.d ? { d: c.d, fresh: Date.now() - c.t < ttl } : null; } catch (e) { return null; } }
  function cacheSet(k, d) { try { localStorage.setItem(k, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }
  function el(tag, cls, text) { var x = document.createElement(tag); if (cls) x.className = cls; if (text != null) x.textContent = text; return x; }
  function waLink(number, text) { return number ? 'https://wa.me/' + number + '?text=' + encodeURIComponent(text) : ''; }
  function fmtDate(iso, withTime) {
    if (!iso) return '';
    var d = new Date(iso); if (isNaN(d)) return '';
    var o = { weekday: 'long', day: 'numeric', month: 'long' };
    if (withTime) o = { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' };
    return d.toLocaleDateString('es-CL', o) + (withTime ? '' : '');
  }
  function rutClean(v) { return String(v || '').replace(/[^0-9kK]/g, '').toUpperCase(); }
  function rutFormat(v) { var r = rutClean(v); return r.length < 2 ? r : r.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + r.slice(-1); }

  // Modal compartido (mismo diseño que el del mensaje postventa)
  function modal(html, actions) {
    var m = document.querySelector('[data-tt-sac-modal]');
    if (!m) {
      m = el('div', 'tt-pv-modal'); m.setAttribute('data-tt-sac-modal', ''); m.hidden = true;
      m.innerHTML = '<div class="tt-pv-modal__overlay" data-close></div><div class="tt-pv-modal__box tt-help-box" role="dialog" aria-modal="true" aria-labelledby="tt-sac-modal-title">' +
        '<div class="tt-pv-modal__card"><div class="tt-pv-modal__head"><span class="tt-pv-modal__avatar" aria-hidden="true">✓</span><h3 id="tt-sac-modal-title">Servicio postventa</h3></div>' +
        '<div class="tt-pv-modal__bubble" data-body></div></div><div class="tt-pv-modal__actions" data-actions></div></div>';
      document.body.appendChild(m);
      m.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) close(); });
    }
    function close() { m.classList.remove('is-open'); document.documentElement.classList.remove('tt-pv-lock'); setTimeout(function () { m.hidden = true; }, 200); }
    m.querySelector('[data-body]').innerHTML = html;
    var box = m.querySelector('[data-actions]'); box.innerHTML = '';
    actions.forEach(function (a) {
      var b = a.href ? el('a', a.cls, null) : el('button', a.cls, null);
      if (a.href) { b.href = a.href; if (a.blank) { b.target = '_blank'; b.rel = 'noopener'; } } else b.type = 'button';
      b.innerHTML = a.html || '';
      b.addEventListener('click', function (e) { if (a.onClick) a.onClick(e); if (a.close !== false) close(); });
      box.appendChild(b);
    });
    m.hidden = false; document.documentElement.classList.add('tt-pv-lock');
    requestAnimationFrame(function () { m.classList.add('is-open'); var f = box.querySelector('a,button'); if (f) f.focus(); });
  }
  var WA_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm4.5 12.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-2-1.2 7.4 7.4 0 0 1-1.4-1.7c-.1-.2 0-.4.1-.5l.4-.4.2-.4v-.4l-.8-1.9c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4 3.7 3.7 0 0 0 1.7.1 2.8 2.8 0 0 0 1.8-1.3 2.3 2.3 0 0 0 .2-1.3c-.1-.1-.3-.2-.5-.3Z"/></svg>';
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // ───────────────────────── Formulario ─────────────────────────
  function initForm(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var c = cfgOf(root);
    var $ = function (s) { return root.querySelector(s); };
    var form = $('[data-sac-form]');
    var field = function (n) { return form.querySelector('[name="' + n + '"]'); };
    var cfg = null, files = [];
    var track = $('[data-sac-track]'); if (track && c.page) track.href = c.page;

    function fatal(msg) { $('[data-sac-loading]').hidden = true; var f = $('[data-sac-fatal]'); f.textContent = msg; f.hidden = false; }
    if (!c.key || !c.api) return fatal('El formulario de solicitudes no está configurado todavía. Escríbenos por WhatsApp mientras tanto.');

    function option(v, l) { var o = document.createElement('option'); o.value = v; o.textContent = l; return o; }
    function category(id) { var f = null; (cfg ? cfg.groups : []).forEach(function (g) { g.categories.forEach(function (x) { if (x.id === id) f = x; }); }); return f; }
    function selectedCategory() { var s = form.querySelector('[data-sac-cat]:not(:disabled)'); return s && s.value ? s.value : ''; }

    function build(r) {
      cfg = r;
      if (!r.groups || !r.groups.length) {   // Shopysale aún sin tipos de consulta: no se puede crear la solicitud
        fatal('Estamos actualizando el formulario de solicitudes. Mientras tanto, escríbenos por WhatsApp y te ayudamos.');
        if (c.wa) { var w = el('a', 'tt-pv-modal__wa tt-sac__wa'); w.href = waLink(c.wa, 'Hola, necesito ayuda de postventa.'); w.target = '_blank'; w.rel = 'noopener'; w.innerHTML = WA_ICON + 'Escribir por WhatsApp'; $('[data-sac-fatal]').after(w); }
        return;
      }
      var box = $('[data-sac-groups]'); box.innerHTML = '';
      r.groups.forEach(function (g, i) {
        var row = el('div', 'tt-pv__cat'); row.setAttribute('data-sac-group', g.group);
        var lab = el('label', 'tt-pv__switch');
        var cb = el('input'); cb.type = 'checkbox'; cb.setAttribute('data-sac-toggle', g.group); if (i === 0) cb.checked = true;
        lab.appendChild(cb); lab.appendChild(el('span', 'tt-pv__track')); lab.lastChild.setAttribute('aria-hidden', 'true');
        var nm = el('span', 'tt-pv__cat-name', g.label); nm.appendChild(el('small', null, '*Uno a la vez')); lab.appendChild(nm);
        var wrap = el('div', 'tt-pv__select');
        var sel = el('select'); sel.setAttribute('data-sac-cat', g.group); sel.setAttribute('aria-label', 'Tipo de consulta de ' + g.label);
        sel.appendChild(option('', 'Selecciona el problema'));
        g.categories.forEach(function (x) { sel.appendChild(option(x.id, x.name)); });
        wrap.appendChild(sel); row.appendChild(lab); row.appendChild(wrap); box.appendChild(row);
      });
      var ch = field('purchase.channel'); ch.length = 1; r.purchaseChannels.forEach(function (x) { ch.appendChild(option(x.value, x.label)); });
      var br = field('purchase.branchId'); br.length = 1; r.branches.forEach(function (x) { br.appendChild(option(x.id, x.name)); });
      if (r.attachments) $('[data-sac-files-help]').textContent = 'JPG, PNG, WEBP o PDF · hasta ' + r.attachments.maxFiles + ' archivos de ' + Math.round(r.attachments.maxBytes / 1048576) + ' MB';
      bindGroups(); refresh();
      $('[data-sac-loading]').hidden = true; form.hidden = false;
    }

    function bindGroups() {
      form.querySelectorAll('[data-sac-toggle]').forEach(function (t) {
        t.addEventListener('change', function () {
          if (t.checked) form.querySelectorAll('[data-sac-toggle]').forEach(function (o) { if (o !== t) o.checked = false; });   // uno a la vez
          refresh();
        });
      });
      form.querySelectorAll('[data-sac-cat]').forEach(function (s) {
        s.addEventListener('change', function () {
          var t = form.querySelector('[data-sac-toggle="' + s.getAttribute('data-sac-cat') + '"]');
          if (s.value && !t.checked) { t.checked = true; t.dispatchEvent(new Event('change')); }
          refresh();
        });
      });
    }

    function refresh() {
      form.querySelectorAll('[data-sac-toggle]').forEach(function (t) {
        var s = form.querySelector('[data-sac-cat="' + t.getAttribute('data-sac-toggle') + '"]');
        s.disabled = !t.checked; if (!t.checked) s.value = '';
        t.closest('.tt-pv__cat').classList.toggle('is-on', t.checked);
      });
      var cat = category(selectedCategory());
      var req = (cat && cat.requiredFields) || [];
      var help = $('[data-sac-cat-help]'); help.textContent = (cat && cat.description) || ''; help.hidden = !help.textContent;
      form.querySelectorAll('[data-sac-need]').forEach(function (n) { n.hidden = req.indexOf(n.getAttribute('data-sac-need')) < 0; });
      $('[data-sac-extra]').hidden = !req.length;
      var chv = field('purchase.channel').value, needP = req.indexOf('purchase') > -1;
      root.querySelector('[data-sac-show="order"]').hidden = !needP || !chv || chv === 'tienda';
      root.querySelector('[data-sac-show="branch"]').hidden = !needP || chv !== 'tienda';
      setErr('categoryId', '');
    }
    field('purchase.channel').addEventListener('change', refresh);
    field('customer.rut').addEventListener('blur', function () { if (this.value) this.value = rutFormat(this.value); });

    function setErr(name, msg) {
      var s = root.querySelector('[data-error="' + name + '"]'); if (s) s.textContent = msg || '';
      var i = field(name === 'product.sku' ? 'product.name' : name);   // "nombre o SKU": se marca el nombre (el SKU es opcional)
      if (i) i.classList.toggle('is-invalid', !!msg);
    }
    function clearErrors() {
      root.querySelectorAll('[data-error]').forEach(function (s) { s.textContent = ''; });
      root.querySelectorAll('.is-invalid').forEach(function (i) { i.classList.remove('is-invalid'); });
      $('[data-sac-error]').hidden = true;
    }
    function showErrors(errors, msg) {
      var first = null;
      Object.keys(errors || {}).forEach(function (k) { setErr(k, errors[k]); var i = field(k === 'product.sku' ? 'product.name' : k); if (i && !first) first = i; });
      var box = $('[data-sac-error]'); box.textContent = msg || 'Revisa los datos marcados.'; box.hidden = false;
      (first || box).scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    // Validación local (la API valida igual; esto evita viajes y muestra los errores al tiro)
    function validate(p, cat) {
      var e = {};
      if (!p.categoryId) e.categoryId = 'Elige el tipo de consulta';
      if (p.customer.name.length < 3) e['customer.name'] = 'Escribe tu nombre completo';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(p.customer.email)) e['customer.email'] = 'Correo no válido';
      if (p.description.length < 10) e.description = 'Cuéntanos un poco más (mínimo 10 caracteres)';
      var req = (cat && cat.requiredFields) || [];
      if (req.indexOf('purchase') > -1) {
        if (!p.purchase.channel) e['purchase.channel'] = 'Indica dónde compraste';
        else if (p.purchase.channel === 'tienda' && !p.purchase.branchId) e['purchase.branchId'] = 'Elige la sucursal';
        else if (p.purchase.channel !== 'tienda' && !p.purchase.orderNumber) e['purchase.orderNumber'] = 'Escribe el n° de pedido';
      }
      if (req.indexOf('sku') > -1 && !p.product.sku && !p.product.name) e['product.sku'] = 'Escribe el nombre o el SKU del producto';
      if (req.indexOf('serialNumber') > -1 && !p.product.serialNumber) e['product.serialNumber'] = 'Escribe el n° de serie';
      if (req.indexOf('purchaseDate') > -1) {
        if (!p.purchase.purchaseDate) e['purchase.purchaseDate'] = 'Indica la fecha de compra';
        else if (new Date(p.purchase.purchaseDate) > new Date()) e['purchase.purchaseDate'] = 'La fecha no puede ser futura';
      }
      return e;
    }

    function renderFiles() {
      var list = $('[data-sac-files-list]'); list.innerHTML = '';
      files.forEach(function (f, i) {
        var li = el('li', null, f.name + ' · ' + Math.ceil(f.size / 1024) + ' KB');
        var rm = el('button', 'tt-sac__rm', 'Quitar'); rm.type = 'button';
        rm.addEventListener('click', function () { files.splice(i, 1); renderFiles(); });
        li.appendChild(rm); list.appendChild(li);
      });
    }
    $('[data-sac-files]').addEventListener('change', function (e) {
      var a = (cfg && cfg.attachments) || { maxFiles: 5, maxBytes: 10485760, types: ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'] };
      var msg = '';
      Array.prototype.forEach.call(e.target.files, function (f) {
        if (a.types.indexOf(f.type) < 0) msg = f.name + ': solo JPG, PNG, WEBP o PDF';
        else if (f.size > a.maxBytes) msg = f.name + ': supera ' + Math.round(a.maxBytes / 1048576) + ' MB';
        else if (files.length >= a.maxFiles) msg = 'Máximo ' + a.maxFiles + ' archivos';
        else files.push(f);
      });
      setErr('attachments', msg); e.target.value = ''; renderFiles();
    });

    function upload(file) {
      return call(c, '/public/tickets/attachments', { method: 'POST', body: { contentType: file.type, size: file.size } }).then(function (r) {
        var fd = new FormData();
        Object.keys(r.upload.fields).forEach(function (k) { fd.append(k, r.upload.fields[k]); });
        fd.append('file', file);   // siempre al final
        return fetch(r.upload.url, { method: 'POST', body: fd }).then(function (s3) {
          if (!s3.ok) throw new Error('No se pudo subir ' + file.name);
          return { key: r.key, name: file.name };
        });
      });
    }
    function payload(att) {
      var v = function (n) { var x = field(n); return x ? x.value.trim() : ''; };
      return {
        categoryId: selectedCategory(),
        customer: { name: v('customer.name'), email: v('customer.email'), phone: v('customer.phone'), rut: v('customer.rut') },
        purchase: { channel: v('purchase.channel'), orderNumber: v('purchase.orderNumber'), branchId: v('purchase.branchId'), documentNumber: v('purchase.documentNumber'), purchaseDate: v('purchase.purchaseDate') },
        product: { sku: v('product.sku'), name: v('product.name'), serialNumber: v('product.serialNumber') },
        subject: '', description: v('description'), attachments: att || [], website: v('website')
      };
    }

    function success(r, p) {
      var code = r.ticket.code;
      var link = c.page + '?ticket=' + encodeURIComponent(code);   // sin token en la URL
      if (r.token) try { sessionStorage.setItem('tt-sac-token:' + code, r.token); } catch (e) {}
      var cat = category(p.categoryId);
      var due = r.ticket.resolutionDueAt ? 'Te responderemos a más tardar el <b>' + esc(fmtDate(r.ticket.resolutionDueAt)) + '</b>.' : '';
      var wa = waLink(c.wa, 'Hola, tengo la solicitud ' + code + ' (' + (cat ? cat.name : 'postventa') + '). Soy ' + p.customer.name + '. Quiero darle seguimiento por aquí.');
      modal(
        '<b>¡Recibimos tu solicitud!</b><br><br>Tu número es<br><b class="tt-sac__code tt-sac__code--big">' + esc(code) + '</b><br>' +
        '<small class="tt-sac__keep">Guárdalo: con este número y tu correo puedes hacer el seguimiento.</small><br><br>' + due +
        '<br><br>Te enviamos un correo a <b>' + esc(p.customer.email) + '</b> con el link para ver el estado y responder. ' +
        (wa ? 'Si prefieres, también puedes seguir por WhatsApp con tu número de solicitud.' : ''),
        [
          { cls: 'tt-pv-modal__back', html: 'Ver mi solicitud', href: link },
          wa ? { cls: 'tt-pv-modal__wa', html: WA_ICON + 'Seguir por WhatsApp', href: wa, blank: true } : null
        ].filter(Boolean)
      );
      form.reset(); files = []; renderFiles(); refresh();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault(); clearErrors();
      var p = payload(); var errs = validate(p, category(p.categoryId));
      if (Object.keys(errs).length) return showErrors(errs, 'Revisa los datos marcados.');
      var btn = $('[data-sac-submit]'); btn.disabled = true; btn.textContent = files.length ? 'Subiendo archivos…' : 'Enviando…';
      Promise.all(files.map(upload))
        .then(function (att) { btn.textContent = 'Enviando…'; p.attachments = att; return call(c, '/public/tickets', { method: 'POST', body: p }); })
        .then(function (r) { success(r, p); })
        .catch(function (err) {
          var msg = err.status === 429 ? 'Hiciste muchas solicitudes seguidas. Intenta en unos minutos o escríbenos por WhatsApp.' : (err.message || 'No pudimos enviar tu solicitud. Intenta de nuevo.');
          showErrors(err.errors, msg);
        })
        .then(function () { btn.disabled = false; btn.textContent = 'Enviar solicitud'; });
    });

    // Config: caché al instante + renovación en segundo plano
    var cached = cacheGet(FORM_CACHE, FORM_TTL);
    if (cached) build(cached.d);
    if (!cached || !cached.fresh) {
      call(c, '/public/tickets/form').then(function (r) { cacheSet(FORM_CACHE, r); if (!cached) build(r); })
        .catch(function (err) { if (!cached) fatal(err.status === 403 ? 'El formulario no está habilitado para este sitio todavía.' : 'No pudimos cargar el formulario. Intenta más tarde o escríbenos por WhatsApp.'); });
    }
  }

  // ───────────────────────── Mi ticket ─────────────────────────
  var STEPS = [['nuevo', 'Recibido'], ['revision', 'En revisión'], ['resuelto', 'Resuelto'], ['cerrado', 'Cerrado']];
  function step(status) { return status === 'nuevo' ? 0 : status === 'resuelto' ? 2 : status === 'cerrado' ? 3 : 1; }

  function initView(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var c = cfgOf(root);
    var $ = function (s) { return root.querySelector(s); };
    var q = new URLSearchParams(location.search);
    var preRate = Math.max(0, Math.min(5, parseInt(q.get('calificar'), 10) || 0));   // botón del correo "¿Cómo te atendimos?"
    // Token guardado POR CÓDIGO (tt-sac-token:SAC-…): el token de un ticket nunca se usa para otro
    function getTok(cd) {
      if (!cd) return '';
      try {
        var t = sessionStorage.getItem('tt-sac-token:' + cd); if (t) return t;
        var au = JSON.parse(sessionStorage.getItem('tt_sac_auth') || 'null');   // formato anterior (una sola clave)
        if (au && au.token && au.code === cd) return au.token;
      } catch (e) {}
      return '';
    }
    function setTok(cd, t) { try { sessionStorage.setItem('tt-sac-token:' + cd, t); } catch (e) {} }
    var code = (q.get('ticket') || '').toUpperCase();
    if (q.get('token') && code) {   // por si el <head> no alcanzó a sacarlo
      setTok(code, q.get('token'));
      try { var cu = new URL(location.href); cu.searchParams.delete('token'); history.replaceState(null, '', cu.pathname + cu.search + cu.hash); } catch (e) {}
    }
    // Ticket abierto ahora: código + token van juntos; gen cambia al cambiar de ticket y
    // descarta respuestas atrasadas (polling, envíos) del ticket anterior
    var auth = { code: code, token: getTok(code) }, gen = 0;
    var lookup = $('[data-sac-lookup]'), view = $('[data-sac-ticket]');

    // Sin link: con n° + correo se abre al tiro (POST /lookup); solo con correo, se reenvía el link
    lookup.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = lookup.querySelector('[name="email"]').value.trim(), cd = lookup.querySelector('[name="code"]').value.trim().toUpperCase();
      var out = $('[data-sac-lookup-msg]');
      function say(t, bad) { out.textContent = t; out.className = 'tt-sac__state' + (bad ? ' tt-sac__state--error' : ''); }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return say('Escribe el correo con el que hiciste la solicitud.', true);
      if (!c.key) return say('Las solicitudes no están disponibles en este momento.', true);
      var b = lookup.querySelector('button'); b.disabled = true;
      var req = cd
        ? call(c, '/public/tickets/lookup', { method: 'POST', body: { code: cd, email: email } }).then(function (r) {
            var nc = String(r.ticket.code).toUpperCase();
            if (r.token) setTok(nc, r.token);
            try { var u = new URL(location.href); u.searchParams.set('ticket', nc); u.searchParams.delete('token'); u.hash = ''; history.replaceState(null, '', u); } catch (er) {}
            say(''); return openTicket(nc, r.token, r.ticket);
          })
        : call(c, '/public/tickets/resend-link', { method: 'POST', body: { email: email } }).then(function (r) { say(r.msg || 'Si el correo tiene solicitudes, te enviamos el link.'); });
      req.catch(function (err) {
        say(err.status === 429 ? 'Demasiados intentos. Prueba en unos minutos.' : err.status === 401 || err.status === 404 ? 'No encontramos una solicitud con ese número y correo. Revisa los datos o déjalo solo con tu correo y te enviamos el link.' : (err.message || 'No pudimos completar la búsqueda.'), true);
      }).then(function () { b.disabled = false; });
    });
    var files = [];

    // Qué hacer en cada estado (lo que ve el cliente)
    function stateBanner(t) {
      var due = t.resolutionDueAt ? fmtDate(t.resolutionDueAt) : '';
      var m = {
        nuevo: ['info', 'Recibimos tu solicitud', 'Un ejecutivo la tomará pronto' + (due ? ' y te responderemos a más tardar el <b>' + esc(due) + '</b>' : '') + '.'],
        abierto: ['info', 'Estamos trabajando en tu solicitud', 'Te avisaremos por correo cuando tengamos novedades. También puedes escribirnos aquí.'],
        esperando_cliente: ['action', 'Necesitamos tu respuesta', 'Revisa el último mensaje de nuestro equipo y respóndenos abajo (puedes adjuntar fotos o tu boleta).'],
        esperando_interno: ['info', 'Estamos esperando una gestión interna', 'Puede ser un repuesto, el servicio técnico o bodega. Te avisaremos por aquí apenas haya novedades.'],
        resuelto: ['done', '¿Se solucionó tu problema?', 'Marcamos tu solicitud como resuelta. Si no te sirve la solución, respóndenos y la reabrimos; si no, se cerrará sola en unos días.'],
        cerrado: ['closed', 'Solicitud cerrada', 'Esta solicitud terminó y ya no recibe respuestas. Si necesitas algo más, crea una nueva solicitud.']
      }[t.status];
      if (!m) return '';
      var actions = '';
      if (t.status === 'resuelto') actions = '<div class="tt-sac__banner-actions"><button type="button" class="tt-pv__btn" data-sac-yes>Sí, gracias</button><button type="button" class="tt-sac__banner-no" data-sac-no>No, sigo con el problema</button></div>';
      if (t.status === 'cerrado') actions = '<div class="tt-sac__banner-actions"><a class="tt-pv__btn" href="' + esc(helpUrl()) + '#contacto-postventa">Crear nueva solicitud</a></div>';
      return '<div class="tt-sac__banner tt-sac__banner--' + m[0] + '" role="status"><b>' + m[1] + '</b><span>' + m[2] + '</span>' + actions + '</div>';
    }
    // ── Encuesta de satisfacción (POST /public/tickets/:code/rating) ──
    var RATE = ['', 'Muy mala', 'Mala', 'Regular', 'Buena', 'Excelente'];
    function rateBox(t, slot, edit) {
      if (!slot) return;
      var sat = t.satisfaction;
      if (!t.canRate && !sat) { slot.innerHTML = ''; return; }   // aún no resuelta (o API sin encuesta)
      if (sat && !edit) {
        slot.innerHTML = '<div class="tt-sac__rate tt-sac__rate--done"><b>¡Gracias por tu opinión!</b>' +
          '<span class="tt-sac__stars-static" aria-label="Calificaste ' + sat.rating + ' de 5">' + '★★★★★'.slice(0, sat.rating) + '<i>' + '★★★★★'.slice(sat.rating) + '</i></span>' +
          '<span>Calificaste ' + sat.rating + '/5 · ' + RATE[sat.rating] + (sat.comment ? ' — “' + esc(sat.comment) + '”' : '') + '</span>' +
          (t.canRate ? '<button type="button" class="tt-sac__banner-no" data-rate-edit>Cambiar calificación</button>' : '') + '</div>';
        var ed = slot.querySelector('[data-rate-edit]'); if (ed) ed.addEventListener('click', function () { rateBox(t, slot, true); });
        return;
      }
      var cur = (sat && sat.rating) || preRate || 0;
      slot.innerHTML = '<form class="tt-pv tt-sac__rate" novalidate><b>¿Cómo te atendimos?</b><span>Tu opinión nos ayuda a mejorar el servicio postventa.</span>' +
        '<div class="tt-sac__stars" role="radiogroup" aria-label="Calificación de 1 a 5">' +
        [1, 2, 3, 4, 5].map(function (n) { return '<button type="button" role="radio" aria-checked="false" data-star="' + n + '" aria-label="' + n + ' de 5: ' + RATE[n] + '">★</button>'; }).join('') +
        '<em data-star-label></em></div>' +
        '<label class="tt-pv__comment"><span class="visually-hidden">Comentario</span><textarea maxlength="1000" rows="2" placeholder="Cuéntanos más (opcional)">' + esc((sat && sat.comment) || '') + '</textarea></label>' +
        '<p class="tt-sac__state tt-sac__state--error" data-rate-err hidden></p>' +
        '<div class="tt-sac__rate-actions"><button type="submit" class="tt-pv__btn">Enviar calificación</button></div></form>';
      var f = slot.querySelector('form'), lab = f.querySelector('[data-star-label]'), stars = f.querySelectorAll('[data-star]');
      function paint(v) {
        stars.forEach(function (b) { var n = +b.getAttribute('data-star'); b.classList.toggle('is-on', n <= v); b.setAttribute('aria-checked', n === v ? 'true' : 'false'); });
        lab.textContent = v ? RATE[v] : 'Elige de 1 a 5 estrellas';
      }
      stars.forEach(function (b) {
        b.addEventListener('click', function () { cur = +b.getAttribute('data-star'); paint(cur); });
        b.addEventListener('mouseenter', function () { paint(+b.getAttribute('data-star')); });
      });
      f.querySelector('.tt-sac__stars').addEventListener('mouseleave', function () { paint(cur); });
      paint(cur);
      if (preRate && !edit) { slot.scrollIntoView({ behavior: 'smooth', block: 'center' }); f.querySelector('textarea').focus(); }
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var err = f.querySelector('[data-rate-err]');
        if (!cur) { err.textContent = 'Elige de 1 a 5 estrellas.'; err.hidden = false; return; }
        var btn = f.querySelector('button[type=submit]'); btn.disabled = true; btn.textContent = 'Enviando…';
        var a = auth, my = gen;
        call(c, '/public/tickets/' + encodeURIComponent(a.code) + '/rating', { method: 'POST', token: a.token, body: { rating: cur, comment: f.querySelector('textarea').value.trim() } })
          .then(function (r) { if (my !== gen) return; preRate = 0; var nt = r.ticket || t; if (!nt.satisfaction) nt.satisfaction = { rating: cur, comment: f.querySelector('textarea').value.trim() }; rateBox(nt, slot, false); })
          .catch(function (er) {
            err.textContent = er.status === 409 ? 'Podrás calificar cuando tu solicitud esté resuelta.' : er.status === 429 ? 'Demasiados intentos. Prueba en unos minutos.' : (er.message || 'No pudimos enviar tu calificación.');
            err.hidden = false; btn.disabled = false; btn.textContent = 'Enviar calificación';
          });
      });
    }

    function helpUrl() { var h = root.closest('[data-tt-sac-host]'); var a = h && h.querySelector('.tt-mt__links a.tt-pv__btn'); return a ? a.getAttribute('href').split('#')[0] : '/pages/centro-de-ayuda'; }

    // ── Chat: burbuja de un mensaje (texto plano con pre-wrap, nunca HTML) ──
    function bubble(m) {
      var ag = m.from === 'agent';
      var b = el('div', 'tt-sac__msg tt-sac__msg--' + (ag ? 'agent' : 'customer'));
      b.setAttribute('data-msg-id', m.id || '');
      var who = el('span', 'tt-sac__who');
      var nm = el('b', null, ag ? (m.authorName || 'Total Tools') : 'Tú');
      who.appendChild(nm); who.appendChild(document.createTextNode(' · ' + fmtDate(m.createdAt, true)));
      b.appendChild(who);
      if (m.body) b.appendChild(el('div', 'tt-sac__body', m.body));
      (m.attachments || []).forEach(function (a) { var l = el('a', 'tt-sac__att', '📎 ' + (a.name || 'Adjunto')); l.href = a.url; l.target = '_blank'; l.rel = 'noopener'; b.appendChild(l); });
      return b;
    }
    function toBottom(smooth) { var ch = view.querySelector('[data-chat]'); if (ch) ch.scrollTo({ top: ch.scrollHeight, behavior: smooth ? 'smooth' : 'auto' }); }
    function nearBottom() { var ch = view.querySelector('[data-chat]'); return !ch || ch.scrollHeight - ch.scrollTop - ch.clientHeight < 80; }
    var toastEl = null, toastT;
    function toast(msg) {
      if (!toastEl) {
        toastEl = el('button', 'tt-sac__toast'); toastEl.type = 'button'; toastEl.setAttribute('role', 'status');
        toastEl.addEventListener('click', function () { toastEl.classList.remove('is-on'); var ch = view.querySelector('[data-chat]'); if (ch) { ch.scrollIntoView({ behavior: 'smooth', block: 'center' }); toBottom(true); } });
        document.body.appendChild(toastEl);
      }
      toastEl.textContent = msg; toastEl.classList.add('is-on');
      clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 7000);
    }
    var current = null, seen = {};
    function sig(t) { return [t.status, t.canReply, t.canRate, JSON.stringify(t.satisfaction || null)].join('|'); }

    function render(t, opts) {
      opts = opts || {};
      // borrador: lo que el cliente está escribiendo no se pierde al refrescar
      var oldTa = view.querySelector('.tt-sac__reply textarea');
      var draft = opts.clear ? '' : (oldTa ? oldTa.value : '');
      var hadFocus = !opts.clear && oldTa && document.activeElement === oldTa, caret = hadFocus ? oldTa.selectionStart : 0;
      if (opts.clear) files = [];
      current = t; seen = {}; (t.messages || []).forEach(function (m) { seen[m.id] = 1; });
      var s = step(t.status);
      var wa = waLink(c.wa, 'Hola, quiero dar seguimiento a mi solicitud ' + t.code + '.');
      var h = '<div class="tt-sac__tk-head"><div><span class="tt-sac__tk-label">Solicitud</span><b class="tt-sac__code">' + esc(t.code) + '</b></div>' +
        '<span class="tt-sac__pill tt-sac__pill--' + esc(t.status) + '">' + esc(t.statusLabel) + '</span></div>' +
        '<ol class="tt-sac__steps">' + STEPS.map(function (x, i) { return '<li class="' + (i < s ? 'is-done' : i === s ? 'is-now' : '') + '">' + x[1] + '</li>'; }).join('') + '</ol>' +
        stateBanner(t) +
        '<div data-sac-rate-slot></div>' +
        '<dl class="tt-sac__meta">' +
          '<div><dt>Tipo</dt><dd>' + esc(t.category ? t.category.group + ' · ' + t.category.name : '') + '</dd></div>' +
          '<div><dt>Creada</dt><dd>' + esc(fmtDate(t.createdAt, true)) + '</dd></div>' +
          (t.resolutionDueAt ? '<div><dt>Respuesta a más tardar</dt><dd>' + esc(fmtDate(t.resolutionDueAt)) + '</dd></div>' : '') +
          (t.purchase && t.purchase.channelLabel ? '<div><dt>Compra</dt><dd>' + esc(t.purchase.channelLabel + (t.purchase.orderNumber ? ' · ' + t.purchase.orderNumber : '') + (t.purchase.branchName ? ' · ' + t.purchase.branchName : '')) + '</dd></div>' : '') +
        '</dl><div class="tt-sac__chat" data-chat></div>';
      view.innerHTML = h;
      var chat = view.querySelector('[data-chat]');
      (t.messages || []).forEach(function (m) { chat.appendChild(bubble(m)); });
      if (t.canReply) {
        var f = el('form', 'tt-pv tt-sac__reply'); f.noValidate = true; f.id = 'responder';
        f.innerHTML = '<label class="tt-pv__comment"><span class="tt-pv__lead">Responder</span><textarea name="body" rows="3" placeholder="Escribe tu respuesta"></textarea></label>' +
          '<div class="tt-sac__reply-row"><input type="file" id="tt-sac-reply-files" multiple accept="image/jpeg,image/png,image/webp,application/pdf" class="tt-sac__file">' +
          '<label for="tt-sac-reply-files" class="tt-sac__clip">📎 Adjuntar</label><span class="tt-sac__clip-list" data-list></span>' +
          '<button type="submit" class="tt-pv__btn">Enviar respuesta</button></div><p class="tt-sac__state tt-sac__state--error" data-err hidden></p>';
        view.appendChild(f);
        var ta = f.querySelector('textarea');
        if (draft) ta.value = draft;
        if (hadFocus) { ta.focus({ preventScroll: true }); ta.setSelectionRange(caret, caret); }
        var fi = f.querySelector('input[type=file]');
        if (files.length) f.querySelector('[data-list]').textContent = files.map(function (x) { return x.name; }).join(', ');
        fi.addEventListener('change', function () { files = Array.prototype.slice.call(fi.files, 0, 5); f.querySelector('[data-list]').textContent = files.map(function (x) { return x.name; }).join(', '); });
        f.addEventListener('submit', function (e) {
          e.preventDefault();
          var txt = f.querySelector('textarea').value.trim(), err = f.querySelector('[data-err]');
          if (!txt && !files.length) { err.textContent = 'Escribe tu respuesta o adjunta un archivo.'; err.hidden = false; return; }
          var btn = f.querySelector('button'); btn.disabled = true; btn.textContent = 'Enviando…';
          var a = auth, my = gen;
          Promise.all(files.map(function (file) {
            return call(c, '/public/tickets/attachments', { method: 'POST', body: { contentType: file.type, size: file.size } }).then(function (r) {
              var fd = new FormData(); Object.keys(r.upload.fields).forEach(function (k) { fd.append(k, r.upload.fields[k]); }); fd.append('file', file);
              return fetch(r.upload.url, { method: 'POST', body: fd }).then(function (s3) { if (!s3.ok) throw new Error('No se pudo subir ' + file.name); return { key: r.key, name: file.name }; });
            });
          })).then(function (att) {
            return call(c, '/public/tickets/' + encodeURIComponent(a.code) + '/messages', { method: 'POST', token: a.token, body: { body: txt, attachments: att } });
          }).then(function (r) { if (my !== gen || !sameTk(r.ticket, a)) return; render(r.ticket, { clear: true }); toBottom(true); })
            .catch(function (er) { err.textContent = er.status === 409 ? 'Esta solicitud está cerrada y ya no recibe respuestas.' : (er.message || 'No pudimos enviar tu respuesta.'); err.hidden = false; btn.disabled = false; btn.textContent = 'Enviar respuesta'; });
        });
      } else {
        // cerrada: el aviso y el botón "Crear nueva solicitud" van en el banner de estado
      }
      if (wa) {
        var w = el('a', 'tt-pv-modal__wa tt-sac__wa'); w.href = wa; w.target = '_blank'; w.rel = 'noopener';
        w.innerHTML = WA_ICON + 'Seguir por WhatsApp'; view.appendChild(w);
      }
      var other = el('button', 'tt-sac__other', 'Ver otra solicitud'); other.type = 'button';
      other.addEventListener('click', closeTicket); view.appendChild(other);
      toBottom(false);
      var slot = view.querySelector('[data-sac-rate-slot]');
      rateBox(t, slot, false);
      var reply = view.querySelector('.tt-sac__reply');
      if (reply && t.status === 'esperando_cliente') reply.classList.add('is-needed');
      var yes = view.querySelector('[data-sac-yes]'), no = view.querySelector('[data-sac-no]');
      // "Sí": NO se envía respuesta (responder reabriría la solicitud); queda resuelta y se cierra sola
      if (yes) yes.addEventListener('click', function () {
        var bn = view.querySelector('.tt-sac__banner');
        bn.innerHTML = '<b>¡Gracias por confirmar!</b><span>Tu solicitud queda resuelta y se cerrará automáticamente. Si vuelve a fallar, crea una nueva solicitud.</span>';
        var rf = slot && slot.querySelector('form');   // y lo llevamos a calificar
        if (rf) { slot.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
      if (no && reply) no.addEventListener('click', function () {
        reply.classList.add('is-needed');
        var ta = reply.querySelector('textarea'); ta.placeholder = 'Cuéntanos qué sigue fallando y la reabrimos';
        reply.scrollIntoView({ behavior: 'smooth', block: 'center' }); ta.focus();
      });
    }

    // ── Actualización sola cada 30 s, solo con la pestaña visible ──
    var polling = false, timer = null;
    function poll() {
      if (polling || document.visibilityState !== 'visible' || !current) return;
      polling = true;
      var a = auth, my = gen;
      call(c, '/public/tickets/' + encodeURIComponent(a.code), { token: a.token })   // con reintento de lecturas
        .then(function (r) {
          if (my !== gen || !sameTk(r.ticket, a)) return;   // llegó tarde: era del ticket anterior
          var t = r.ticket, nuevos = (t.messages || []).filter(function (m) { return !seen[m.id]; });
          var deAgente = nuevos.some(function (m) { return m.from === 'agent'; });
          if (sig(t) !== sig(current)) {
            var bottom = nearBottom(); render(t); if (bottom) toBottom(true);
            toast(deAgente ? 'Nueva respuesta del equipo' : 'Tu solicitud cambió: ' + t.statusLabel);
          } else if (nuevos.length) {
            var ch = view.querySelector('[data-chat]'), bottom2 = nearBottom();
            nuevos.forEach(function (m) { seen[m.id] = 1; ch.appendChild(bubble(m)); });
            current = t; if (bottom2) toBottom(true);
            if (deAgente) toast('Nueva respuesta del equipo');
          }
        })
        .catch(function () {})
        .then(function () { polling = false; });
    }
    function startPolling() { if (!timer) timer = setInterval(poll, 30000); }
    function stopPolling() { clearInterval(timer); timer = null; }
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') poll(); });
    function sameTk(t, a) { return !!t && String(t.code || '').toUpperCase() === a.code; }

    // Cambiar de ticket: corta el polling y vacía todo lo del anterior antes de cargar el nuevo
    function reset() {
      gen++; stopPolling();
      current = null; seen = {}; files = [];
      if (toastEl) toastEl.classList.remove('is-on');
      view.innerHTML = '';
    }
    function openTicket(cd, tk, preloaded) {
      reset();
      var a = auth = { code: cd, token: tk }, my = gen;
      lookup.hidden = true; view.hidden = false;
      view.innerHTML = '<p class="tt-sac__state">Cargando tu solicitud…</p>';
      var req = preloaded ? Promise.resolve({ ticket: preloaded }) : call(c, '/public/tickets/' + encodeURIComponent(cd), { token: tk });
      return req.then(function (r) {
        if (my !== gen) return false;
        if (!sameTk(r.ticket, a)) { var e = new Error('Ticket distinto'); e.status = 401; throw e; }
        render(r.ticket); startPolling(); return true;
      });
    }
    function closeTicket() {
      reset(); auth = { code: '', token: '' };
      view.hidden = true; lookup.hidden = false;
      var m = $('[data-sac-lookup-msg]'); m.textContent = ''; m.className = 'tt-sac__state';
      var cd = lookup.querySelector('[name="code"]'); if (cd) cd.value = '';
      try { var u = new URL(location.href); u.searchParams.delete('ticket'); u.searchParams.delete('calificar'); u.hash = ''; history.replaceState(null, '', u); } catch (e) {}
      lookup.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    if (!auth.code || !auth.token || !c.key) {
      var pre = lookup.querySelector('[name="code"]'); if (pre && auth.code) pre.value = auth.code;   // ?ticket= sin token: solo prellenar
      return;
    }
    openTicket(auth.code, auth.token)
      .then(function (ok) {
        if (!ok) return;
        // link "Responder en mi ticket" de los correos (…#responder)
        if (location.hash === '#responder') {
          var rf = view.querySelector('#responder');
          if (rf) { setTimeout(function () { rf.scrollIntoView({ behavior: 'smooth', block: 'center' }); rf.querySelector('textarea').focus({ preventScroll: true }); }, 150); }
        }
      })
      .catch(function (err) {
        view.hidden = true; lookup.hidden = false;
        var out = $('[data-sac-lookup-msg]');
        out.textContent = err.status === 401 ? 'El link no es válido o venció. Escribe tu correo y te enviamos uno nuevo.' : 'No pudimos cargar tu solicitud. Intenta de nuevo.';
        out.className = 'tt-sac__state tt-sac__state--error';
        var cd = lookup.querySelector('[name="code"]'); if (cd) cd.value = code;
      });
  }

  function run() {
    document.querySelectorAll('[data-tt-sac]').forEach(initForm);
    document.querySelectorAll('[data-tt-sac-view]').forEach(initView);
  }
  window.ttSac = { init: run };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
